import { useEffect, useState } from "react";
import QRCode from "qrcode";

export function QRImage({ value, size = 120 }) {
  const [src, setSrc] = useState("");
  useEffect(() => {
    let ok = true;
    QRCode.toDataURL(value, { margin: 1, width: size * 2 })
      .then((d) => { if (ok) setSrc(d); })
      .catch(() => {});
    return () => { ok = false; };
  }, [value, size]);
  return src ? (
    <img data-testid="login-qr" src={src} alt="Login QR code" width={size} height={size} style={{ borderRadius: 8 }} />
  ) : (
    <div className="animate-pulse rounded-lg bg-secondary" style={{ width: size, height: size }} />
  );
}
